import { useContext, useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'

import { MAX_MOBILE_WIDTH } from '../../constants/layout.js'
import { ID_PERFIL_VENDEDOR } from '../../constants/perfiles.js'
import { cerrarSesion } from '../../helpers/cerrarSesion'
import {
  publicacionesVencidas,
  tiendaOficialVencimiento
} from '../../helpers/notificarVencimientos.js'
import { useAuth } from '../../hooks/useAuth'
import { setIsMobile } from '../../slices/clientDataSlice'
import { CarritoContext } from '../context/carritoContext'
import { MenuContext } from '../context/menuContext'
import ImagenPerfil from '../imagen/ImagenPerfil'
import MenuFavoritos from '../MenuFavoritos'
import { buscarTodasOptimizado } from '../servicios/publicacionesService'
import { buscarPorUsuario } from '../servicios/tiendasOficialesService.js'
import LinkButton from '../ui/LinkButton'
import styles from './Cabecera.module.css'
import CabeceraBuscador from './CabeceraBuscador'
import DropdownNotificacion from './DropdownNotificacion'

const Cabecera = () => {
  const { desplegarMenu, menuAbierto } = useContext(MenuContext)
  const { cantidad, setVerCarrito } = useContext(CarritoContext)
  const {
    loginDataContext: { idUsuario, nombre, empid, idPerfil } = {},
    logout,
    mostrarAvisoSesion,
    extenderSesion,
    cerrarSesionPorInactividad
  } = useAuth()
  const [refreshNotificaciones, setRefreshNotificaciones] = useState(false)
  const dispatch = useDispatch()
  const { isMobile } = useSelector((state) => state.clientData)

  const handleRevokeToken = () => {
    cerrarSesion(logout)
  }

  const fetchData = async (idUsuario) => {
    const { data: publicaciones } = await buscarTodasOptimizado(0, idUsuario, 0, '')
    const { data: tienda } = await buscarPorUsuario(idUsuario)
    let notificaTienda = false
    let notificaPublicacion = false

    if (tienda) {
      notificaTienda = await tiendaOficialVencimiento(tienda, idUsuario, publicaciones)
    }

    if (publicaciones.length > 0) {
      notificaPublicacion = await publicacionesVencidas(publicaciones, idUsuario)
    }
    if (notificaPublicacion || notificaTienda) {
      setRefreshNotificaciones(true)
    }
  }

  useEffect(() => {
    if (idUsuario) {
      fetchData(idUsuario)
    }
  }, [idUsuario])

  useEffect(() => {
    // Detectar cambios en el tamaño de la ventana para actualizar el estado de isMobile.
    // Se ejecuta solo cuando pasa de un lado de MAX_MOBILE_WIDTH al otro.
    const mediaQuery = window.matchMedia(`(max-width: ${MAX_MOBILE_WIDTH}px)`)
    const onChange = (e) => dispatch(setIsMobile(e.matches))

    mediaQuery.addEventListener('change', onChange)
    dispatch(setIsMobile(mediaQuery.matches))

    return () => mediaQuery.removeEventListener('change', onChange)
  }, [dispatch])

  return (
    <>
      <div className={styles.header}>
        <div className={styles.leftHeader}>
          {!isMobile && (
            <div className={styles.logo}>
              <Link className={styles.ebm} to="/Publicaciones">
                e-buymarket<span className={styles.com}>.com</span>
              </Link>
            </div>
          )}

          <div className={styles.leftHeaderWithoutLogo}>
            <label
              htmlFor="menu-bar"
              data-bs-toggle="collapse"
              data-menu-toggle
              onClick={() => desplegarMenu(!menuAbierto)}
              className={styles.menuIcon}
            >
              <i className={`fa ${menuAbierto ? 'fa-times' : 'fa-bars'}`} aria-hidden="true" />
            </label>

            {empid && idUsuario && (
              <div className={styles.profileContainer}>
                <NavLink
                  to="/Perfil"
                  className={({ isActive }) => (isActive ? styles.perfil_active : '')}
                >
                  <div className={styles.cont_perfil_img}>
                    <ImagenPerfil idUsuario={idUsuario} clase={styles.perfil_img} />
                  </div>
                </NavLink>

                <div className={styles.profileNameContainer}>
                  <NavLink
                    className={({ isActive }) =>
                      `${styles.perfil}${isActive ? ` ${styles.perfil_active}` : ''}`
                    }
                    to="/Perfil"
                  >
                    {nombre}
                  </NavLink>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={styles.centerHeader}>
          <div className={styles.contenedorSearch}>
            <CabeceraBuscador />
          </div>

          {!isMobile && (
            <div className={styles.barra_acceso_directo}>
              <MenuFavoritos />
            </div>
          )}
        </div>

        <div className={styles.rightHeader}>
          <div className={styles.logoutButtonContainer}>
            <Button variant="danger" onClick={handleRevokeToken}>
              <i className={`fa fa-sign-out ${styles.icon_salir}`} aria-hidden="true" />
              Salir
            </Button>
          </div>

          <div className={styles.notificationsCartContainer}>
            <div id="esUnificado">
              <DropdownNotificacion refreshKey={refreshNotificaciones} />
            </div>
            {idPerfil !== ID_PERFIL_VENDEDOR && (
              <div id="contenedorNotificacionCarrito">
                <Link
                  to={'/Carrito'}
                  id="notificacion-carrito"
                  className="btn btn-notificaciones"
                  onClick={() => setVerCarrito(false)}
                >
                  <i className="fa fa-shopping-cart" aria-hidden="true" />
                  <span className="badge badge-light">{cantidad}</span>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        show={mostrarAvisoSesion}
        onHide={cerrarSesionPorInactividad}
        backdrop={'static'}
        className="w-25 ml-auto mr-auto"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Psst!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col">
              ¿Sigues ahí?..
              <br />
              Si no confirmas, tu sesión finalizará.
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <LinkButton
            className="btn btn-danger"
            to="/login/"
            onClick={() => cerrarSesionPorInactividad()}
          >
            Cerrar Sesión
          </LinkButton>
          <LinkButton className="btn btn-primary" onClick={() => extenderSesion()}>
            ¡Aún sigo aquí!
          </LinkButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Cabecera
